import { render, staticRenderFns } from "./sexAndAge.vue?vue&type=template&id=75cd5fbe&scoped=true"
import script from "./sexAndAge.vue?vue&type=script&lang=js"
export * from "./sexAndAge.vue?vue&type=script&lang=js"
import style0 from "./sexAndAge.vue?vue&type=style&index=0&id=75cd5fbe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75cd5fbe",
  null
  
)

export default component.exports